/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DriverRankingDetailAdminDto } from '../models/DriverRankingDetailAdminDto';
import type { DriverRankingPeriodStatus } from '../models/DriverRankingPeriodStatus';
import type { GetDriverRankingAcceptanceDailyResponseDriver } from '../models/GetDriverRankingAcceptanceDailyResponseDriver';
import type { GetDriverRankingAdherenceDailyResponseDriver } from '../models/GetDriverRankingAdherenceDailyResponseDriver';
import type { GetDriverRankingOverviewResponseDriver } from '../models/GetDriverRankingOverviewResponseDriver';
import type { GetDriverRankingPenaltiesResponseDriver } from '../models/GetDriverRankingPenaltiesResponseDriver';
import type { Pagination1OfDriverRankingListedAdminDto } from '../models/Pagination1OfDriverRankingListedAdminDto';
import type { Pagination1OfDriverRankingPeriodAdminDto } from '../models/Pagination1OfDriverRankingPeriodAdminDto';
import type { PostDriverRankingManualRunAdminRequest } from '../models/PostDriverRankingManualRunAdminRequest';
import type { ValidateDriverRankingManualRunAdminResponse } from '../models/ValidateDriverRankingManualRunAdminResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DriverRankingsService {
    /**
     * @returns GetDriverRankingOverviewResponseDriver OK
     * @throws ApiError
     */
    public static getDriverRankingOverviewDriver(): CancelablePromise<GetDriverRankingOverviewResponseDriver> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/driverrankings',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetDriverRankingAcceptanceDailyResponseDriver OK
     * @throws ApiError
     */
    public static getCurrentAcceptanceDailyDriver(): CancelablePromise<GetDriverRankingAcceptanceDailyResponseDriver> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/driverrankings/current/acceptance-daily',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetDriverRankingAdherenceDailyResponseDriver OK
     * @throws ApiError
     */
    public static getCurrentAdherenceDailyDriver(): CancelablePromise<GetDriverRankingAdherenceDailyResponseDriver> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/driverrankings/current/adherence-daily',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetDriverRankingPenaltiesResponseDriver OK
     * @throws ApiError
     */
    public static getCurrentPenaltiesDriver(): CancelablePromise<GetDriverRankingPenaltiesResponseDriver> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/driverrankings/current/penalties',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetDriverRankingAcceptanceDailyResponseDriver OK
     * @throws ApiError
     */
    public static getLatestAcceptanceDailyDriver(): CancelablePromise<GetDriverRankingAcceptanceDailyResponseDriver> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/driverrankings/latest/acceptance-daily',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetDriverRankingAdherenceDailyResponseDriver OK
     * @throws ApiError
     */
    public static getLatestAdherenceDailyDriver(): CancelablePromise<GetDriverRankingAdherenceDailyResponseDriver> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/driverrankings/latest/adherence-daily',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetDriverRankingPenaltiesResponseDriver OK
     * @throws ApiError
     */
    public static getLatestPenaltiesDriver(): CancelablePromise<GetDriverRankingPenaltiesResponseDriver> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/driverrankings/latest/penalties',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `RunDriverRankingsManually`
     * @returns ValidateDriverRankingManualRunAdminResponse OK
     * @throws ApiError
     */
    public static validateRunDriverRankingsManuallyAdmin({
        requestBody,
    }: {
        requestBody?: PostDriverRankingManualRunAdminRequest,
    }): CancelablePromise<ValidateDriverRankingManualRunAdminResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driverrankings/run-manually/validate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `RunDriverRankingsManually`
     * @returns any OK
     * @throws ApiError
     */
    public static runDriverRankingsManuallyAdmin({
        requestBody,
    }: {
        requestBody?: PostDriverRankingManualRunAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driverrankings/run-manually',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverRankings`
     * @returns Pagination1OfDriverRankingListedAdminDto OK
     * @throws ApiError
     */
    public static getDriverRankingsAdmin({
        regionId,
        rankingPeriodIds,
        tierName,
        driverId,
        driverName,
        page,
        limit,
    }: {
        regionId?: number,
        rankingPeriodIds?: Array<string>,
        tierName?: string,
        driverId?: number,
        driverName?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfDriverRankingListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driverrankings',
            query: {
                'regionId': regionId,
                'rankingPeriodIds': rankingPeriodIds,
                'tierName': tierName,
                'driverId': driverId,
                'driverName': driverName,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverRankings`
     * @returns Pagination1OfDriverRankingPeriodAdminDto OK
     * @throws ApiError
     */
    public static getDriverRankingPeriodsAdmin({
        regionId,
        startDate,
        endDate,
        status,
        page,
        limit,
    }: {
        regionId?: number,
        startDate?: string,
        endDate?: string,
        status?: DriverRankingPeriodStatus,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfDriverRankingPeriodAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driverrankings/periods',
            query: {
                'regionId': regionId,
                'startDate': startDate,
                'endDate': endDate,
                'status': status,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverRankings`
     * @returns DriverRankingDetailAdminDto OK
     * @throws ApiError
     */
    public static getDriverRankingByIdAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<DriverRankingDetailAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driverrankings/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
